"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var demographics_1 = require("../demographics");
var types_1 = require("../types");
var IncaVariableBase_1 = require("./IncaVariableBase");
var constants_2 = require("./constants");
var utils_1 = require("@nexxt/common/utils");
/**
 * IncaVariableEval instances specify a logical function applied dynamically to a particular inca variable.
 * Such a reference is defined with respect to a particular inca variable and logical function,
 * and exposes methods used to execute the evaluation of the function on the specified variable.
 */
var IncaVariableEval = /** @class */ (function (_super) {
    __extends(IncaVariableEval, _super);
    function IncaVariableEval(question) {
        var _this = _super.call(this, question) || this;
        _this.includesOption = function (answer, opts) {
            switch (answer.type) {
                case types_1.ATYPES.NUMERIC:
                    var ansOptKey_1 = "".concat(answer.questionId, "_").concat(answer.value);
                    return opts.some(function (opt) { return opt.optionKey === ansOptKey_1; });
                case types_1.ATYPES.SINGLE_OPTION:
                    return opts.some(function (opt) { return opt.optionKey === answer.option.optionKey; });
                case types_1.ATYPES.MULTIPLE_OPTIONS:
                    /** @PROJECT BRADO - FOR RANK ORDER - use the first choice to validate the condition rule */
                    if ([25325, 25559, 25512].includes(answer.questionId)) {
                        return opts.some(function (opt) { return opt.optionKey === answer.values[0].optionKey; });
                    }
                    return opts.some(function (opt) {
                        return answer.values.some(function (ans) { return ans.optionKey === opt.optionKey; });
                    });
                case types_1.ATYPES.VECTOR_MAP:
                    if (answer.option.value === constants_1.NA_OPTION_VALUE) {
                        return opts.some(function (opt) { return opt.value === answer.option.value; });
                    }
                    return opts.some(function (opt) { return opt.label === answer.option.value; });
                // Once we change VECTOR MAP answer type.
                // return opts.some(opt => opt.value.split('/').pop() === answer.option.value);
                case types_1.ATYPES.ICONS:
                    if (opts.some(function (opt) { return opt.value === constants_1.NA_OPTION_VALUE; })) {
                        return opts.some(function (opt) { return opt.optionKey === answer.option.optionKey; });
                    }
                    else {
                        return opts.some(function (opt) { return opt.optionKey === answer.option.optionKey; });
                    }
                case types_1.ATYPES.JOURNEY_SELECT:
                    // only works for not applicable! (journeySteps = [])
                    return (!answer.journeySteps.length &&
                        opts.some(function (opt) { return opt.value === constants_1.NA_OPTION_VALUE; }));
                case types_1.ATYPES.TRADE_OFF:
                    return opts.some(function (opt) { return opt.optionKey === answer.option.optionKey; });
                case types_1.ATYPES.NUMERIC:
                    // only applies to Not Applicable option
                    return answer.value === constants_1.NA_OPTION_VALUE;
                default:
                    throw new Error("Answer type ".concat(answer.type, " not supported."));
            }
        };
        _this.doesNotIncludeOption = function (answer, opts) {
            return !_this.includesOption(answer, opts);
        };
        /**
         * Filter the answers by rank.value to validate conditions with specific rank order.
         * @returns boolean
         */
        _this.includesOptionsWithRank = function (answer, opts, rank) {
            switch (true) {
                case rank.value === 0: // 'ANY'
                    return _this.includesOption(answer, opts);
                default:
                    var rankIndex = rank.value - 1;
                    var values = [
                        answer.values[rankIndex]
                    ];
                    return _this.includesOption(__assign(__assign({}, answer), { values: values }), opts);
            }
        };
        _this.doesNotIncludeOptionWithRank = function (answer, opts, rank) {
            return !_this.includesOptionsWithRank(answer, opts, rank);
        };
        _this.equalNumberOptions = function (answer, num) {
            if (answer.type === types_1.ATYPES.MULTIPLE_OPTIONS) {
                var filteredOptions = answer.values.filter(function (opt) { return opt.value !== constants_1.NA_OPTION_VALUE; });
                return filteredOptions.length === num;
            }
            else {
                throw new Error("Answer type ".concat(answer.type, " not supported."));
            }
        };
        _this.greaterNumberOptions = function (answer, num) {
            if (answer.type === types_1.ATYPES.MULTIPLE_OPTIONS) {
                var filteredOptions = answer.values.filter(function (opt) { return opt.value !== constants_1.NA_OPTION_VALUE; });
                return filteredOptions.length > num;
            }
            else {
                throw new Error("Answer type ".concat(answer.type, " not supported."));
            }
        };
        _this.lessNumberOptions = function (answer, num) {
            if (answer.type === types_1.ATYPES.MULTIPLE_OPTIONS) {
                var filteredOptions = answer.values.filter(function (opt) { return opt.value !== constants_1.NA_OPTION_VALUE; });
                return filteredOptions.length < num;
            }
            else {
                throw new Error("Answer type ".concat(answer.type, " not supported."));
            }
        };
        _this.stringContains = function (answer, compareText) {
            if (answer.type === types_1.ATYPES.TEXT) {
                return answer.value.includes(compareText);
            }
            else {
                throw new Error("Answer type ".concat(answer.type, " not supported."));
            }
        };
        _this.stringDoesNotContain = function (answer, compareText) {
            return !_this.stringContains(answer, compareText);
        };
        _this.stringEqauls = function (answer, compareText) {
            if (answer.type === types_1.ATYPES.TEXT) {
                return answer.value == compareText;
            }
            else {
                throw new Error("Answer type ".concat(answer.type, " not supported."));
            }
        };
        _this.stringDoesNotEqual = function (answer, compareText) {
            return !_this.stringEqauls(answer, compareText);
        };
        _this.likeText = function (answer, compareText) {
            throw new Error("Answer type ".concat(answer.type, " not supported."));
        };
        _this.matchesRegex = function (answer, targetRegex) {
            throw new Error("Answer type ".concat(answer.type, " not supported."));
        };
        _this.numericGreaterThan = function (answer, compareNumber) {
            if ([types_1.ATYPES.TEXT, types_1.ATYPES.NUMERIC].includes(answer.type)) {
                return Number(answer['value']) > compareNumber;
            }
            else {
                throw new Error("Answer type ".concat(answer.type, " not supported."));
            }
        };
        _this.numericGreaterThanOrEquals = function (answer, compareNumber) {
            return (_this.numericGreaterThan(answer, compareNumber) ||
                _this.numericEquals(answer, compareNumber));
        };
        _this.numericEquals = function (answer, compareNumber) {
            if ([types_1.ATYPES.TEXT, types_1.ATYPES.NUMERIC].includes(answer.type)) {
                return Number(answer['value']) == compareNumber;
            }
            else {
                throw new Error("Answer type ".concat(answer.type, " not supported."));
            }
        };
        _this.numericDoesNotEqual = function (answer, compareNumber) {
            return !_this.numericEquals(answer, compareNumber);
        };
        _this.numericLessThan = function (answer, compareNumber) {
            if ([types_1.ATYPES.TEXT, types_1.ATYPES.NUMERIC].includes(answer.type)) {
                return Number(answer['value']) < compareNumber;
            }
            else {
                throw new Error("Answer type ".concat(answer.type, " not supported."));
            }
        };
        _this.numericLessThanOrEquals = function (answer, compareNumber) {
            return (_this.numericLessThan(answer, compareNumber) ||
                _this.numericEquals(answer, compareNumber));
        };
        _this.isDisplayed = function (answer) {
            if (answer) {
                return true;
            }
            else {
                return false;
            }
        };
        _this.isNotDisplayed = function (answer) {
            return !_this.isDisplayed(answer);
        };
        /**
         * Returns true if any of the @targets were detected in the @dialogue
         */
        _this.isTargetsDetected = function (dialogue, targetIds) {
            return targetIds.some(function (targetId) {
                return dialogue.detected_target_ids.includes(targetId);
            });
        };
        /**
         * Returns true if none of the @targets were detected in the @dialogue
         */
        _this.isNotTargetsDetected = function (dialogue, targetIds) {
            return !_this.isTargetsDetected(dialogue, targetIds);
        };
        return _this;
    }
    IncaVariableEval.prototype.getIncaVariableFunction = function () {
        var supportedFunctionTypes = this.getIncaVariable().supportedFunctionTypes;
        return constants_2.IncaVariableFunctions.filter(function (variableFunction) {
            return supportedFunctionTypes.includes(variableFunction.type);
        });
    };
    IncaVariableEval.prototype.getIncaVariableFunctionByFunctionValue = function (value) {
        return constants_2.IncaVariableFunctions.find(function (variableFunction) { return variableFunction.value == value; });
    };
    // Get icon scale as an built-in option
    IncaVariableEval.prototype.getIconScaleOptions = function (question) {
        var numberOptions = question.iconNumber;
        var options = [];
        for (var i = 1; i <= numberOptions; i++) {
            var value = constants_1.ICON_OPTION_VALUE[i - 1];
            options = __spreadArray(__spreadArray([], options, true), [
                {
                    label: i,
                    value: value,
                    optionKey: "".concat(question.id, "_").concat(value),
                    id: constants_1.BUILTIN_OPTION_ID
                }
            ], false);
        }
        return options;
    };
    // Get state/province as built-in an option
    IncaVariableEval.prototype.getVectorMapOptions = function (question) {
        var identifier = (question === null || question === void 0 ? void 0 : question.selectedRegion).identifier || '';
        var options = [];
        if (identifier) {
            var regionList = Object.keys(constants_1.VECTOR_MAP_REGION_CODES).filter(function (code) { return code.split('/')[3] === identifier; });
            options = regionList.map(function (region) {
                var value = constants_1.DYNATA_VMAP_MAPPING[region] || region;
                return {
                    id: constants_1.BUILTIN_OPTION_ID,
                    label: constants_1.VECTOR_MAP_REGION_CODES[region],
                    // DYNATA MAPPING FOR DYNATA ONLY(FOR US / CA)
                    value: value,
                    optionKey: "".concat(question.id, "_").concat(value)
                };
            });
            options.sort(function (a, b) {
                return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
            });
        }
        return options;
    };
    IncaVariableEval.prototype.getQuestionOption = function (currentProject) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        var question = this.getQuestion();
        var options = [];
        var questionOptions = question === null || question === void 0 ? void 0 : question.options;
        if (question.isAudience &&
            question.builtInID &&
            [types_1.QTYPES.MULTIPLE_CHOICE, types_1.QTYPES.SINGLE_CHOICE].includes(question.type)) {
            var countryValue = (_b = (_a = currentProject.countries) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value;
            questionOptions = (0, demographics_1.getDemographicDetails)(currentProject.languages, question.builtInID, countryValue, null, { questionId: question.id }).options.map(function (opt) { return ({
                id: opt.id,
                label: opt.label,
                value: opt.value,
                optionKey: opt.optionKey
            }); });
        }
        switch (question.type) {
            case types_1.QTYPES.SINGLE_CHOICE:
            case types_1.QTYPES.MULTIPLE_CHOICE:
            case types_1.QTYPES.SCALE:
            case types_1.QTYPES.RANK_ORDER:
            case types_1.QTYPES.MULTI_POPUP_CARD:
            case types_1.QTYPES.POPUP_CARD:
            case types_1.QTYPES.POPUP:
            case types_1.QTYPES.RATE_IMAGE:
            case types_1.QTYPES.TRADE_OFF:
            case types_1.QTYPES.VIRTUAL:
            case types_1.QTYPES.HOTSPOT:
                options = questionOptions || [];
                break;
            case types_1.QTYPES.ICONS:
                options = this.getIconScaleOptions(question);
                break;
            case types_1.QTYPES.VECTOR_MAP:
                options = this.getVectorMapOptions(question);
                break;
            case types_1.QTYPES.LANGUAGE:
                currentProject.languages.forEach(function (l) {
                    var newOption = {
                        label: l.label,
                        value: l.optionValue,
                        id: constants_1.BUILTIN_OPTION_ID,
                        optionKey: l.optionValue
                    };
                    options = __spreadArray(__spreadArray([], options, true), [newOption], false);
                });
                break;
            case types_1.QTYPES.PANEL:
            case types_1.QTYPES.SPECIALS:
                options = (_c = currentProject.panelSettings) === null || _c === void 0 ? void 0 : _c.panels.map(function (panel, i) {
                    return {
                        label: panel.name || '(no name)',
                        value: i ? panel.key : 'DEFAULT',
                        id: constants_1.BUILTIN_OPTION_ID,
                        optionKey: i ? panel.key : 'DEFAULT'
                    };
                });
                break;
            case types_1.QTYPES.DEVICE:
                currentProject.devices.forEach(function (d) {
                    var newOption = {
                        label: d,
                        id: constants_1.BUILTIN_OPTION_ID,
                        value: constants_1.DEVICE_OPTION_VALUE_PREFIX + d,
                        optionKey: constants_1.DEVICE_OPTION_VALUE_PREFIX + d
                    };
                    options = __spreadArray(__spreadArray([], options, true), [newOption], false);
                });
                break;
            case types_1.QTYPES.NPS:
                for (var i = 0; i < 11; i++) {
                    options.push({
                        id: constants_1.BUILTIN_OPTION_ID,
                        value: "".concat(constants_1.NPS_OVALUE, "/").concat(i.toString()),
                        label: i.toString(),
                        optionKey: "".concat(question.id, "_").concat(constants_1.NPS_OVALUE, "/").concat(i.toString())
                    });
                }
                break;
        }
        if (question.showNotApplicableOption) {
            options = __spreadArray(__spreadArray([], options, true), [
                {
                    label: ((_g = (_f = (_e = (_d = question === null || question === void 0 ? void 0 : question.notApplicableTexts) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.contents) === null || _f === void 0 ? void 0 : _f[0]) === null || _g === void 0 ? void 0 : _g.text) || constants_1.NA_DEFAULT_TEXT,
                    value: constants_1.NA_OPTION_VALUE,
                    id: constants_1.BUILTIN_OPTION_ID,
                    optionKey: "".concat(question.id, "_").concat(constants_1.NA_OPTION_VALUE)
                }
            ], false);
        }
        if ((_h = question === null || question === void 0 ? void 0 : question.optionSettings) === null || _h === void 0 ? void 0 : _h.showOther) {
            options = __spreadArray(__spreadArray([], options, true), [
                {
                    label: ((_m = (_l = (_k = (_j = question.optionSettings.otherOption) === null || _j === void 0 ? void 0 : _j.texts) === null || _k === void 0 ? void 0 : _k[0].contents) === null || _l === void 0 ? void 0 : _l[0]) === null || _m === void 0 ? void 0 : _m.text) || constants_1.OTHER_DEFAULT_TEXT,
                    value: constants_1.OTHER_OPTION_VALUE,
                    id: constants_1.BUILTIN_OPTION_ID,
                    optionKey: "".concat(question.id, "_").concat(constants_1.OTHER_OPTION_VALUE)
                }
            ], false);
        }
        return options;
    };
    IncaVariableEval.prototype.getReferenceQuestionAnswer = function (state, referenceQuestion, rule) {
        var _a, _b, _c, _d, _e, _f;
        var referenceQuestionAnswer;
        switch (referenceQuestion.type) {
            case types_1.QTYPES.DEVICE:
                referenceQuestionAnswer = {
                    questionId: referenceQuestion.id,
                    questionValue: referenceQuestion.value,
                    type: types_1.ATYPES.SINGLE_OPTION,
                    option: {
                        id: constants_1.BUILTIN_OPTION_ID,
                        value: constants_1.DEVICE_OPTION_VALUE_PREFIX + state.deviceType,
                        label: state.deviceType,
                        optionKey: constants_1.DEVICE_OPTION_VALUE_PREFIX + state.deviceType
                    }
                };
                break;
            case types_1.QTYPES.PANEL:
            case types_1.QTYPES.SPECIALS:
                referenceQuestionAnswer = {
                    questionId: referenceQuestion.id,
                    questionValue: referenceQuestion.value,
                    type: types_1.ATYPES.SINGLE_OPTION,
                    option: {
                        id: constants_1.BUILTIN_OPTION_ID,
                        label: ((_a = state === null || state === void 0 ? void 0 : state.panelQueryParams) === null || _a === void 0 ? void 0 : _a.src) || 'DEFAULT',
                        value: ((_b = state === null || state === void 0 ? void 0 : state.panelQueryParams) === null || _b === void 0 ? void 0 : _b.src) || 'DEFAULT',
                        optionKey: ((_c = state === null || state === void 0 ? void 0 : state.panelQueryParams) === null || _c === void 0 ? void 0 : _c.src) || 'DEFAULT'
                    }
                };
                break;
            case types_1.QTYPES.URL_METADATA:
                var urlKey = ((_d = rule === null || rule === void 0 ? void 0 : rule.compareCustomValue) === null || _d === void 0 ? void 0 : _d.key) || '';
                if (urlKey) {
                    referenceQuestionAnswer = {
                        questionId: referenceQuestion.id,
                        questionValue: referenceQuestion.value,
                        type: types_1.ATYPES.TEXT,
                        value: (_f = (_e = state === null || state === void 0 ? void 0 : state.panelQueryParams) === null || _e === void 0 ? void 0 : _e.metadata) === null || _f === void 0 ? void 0 : _f[urlKey]
                    };
                }
                break;
            case types_1.QTYPES.LANGUAGE:
                var selectedLanguage = constants_1.projectLanguage.find(function (language) { return language.value == state.langId; });
                referenceQuestionAnswer = {
                    questionId: referenceQuestion.id,
                    questionValue: referenceQuestion.value,
                    type: types_1.ATYPES.SINGLE_OPTION,
                    option: {
                        id: constants_1.BUILTIN_OPTION_ID,
                        value: selectedLanguage.value,
                        label: selectedLanguage.label,
                        optionKey: selectedLanguage.optionValue
                    }
                };
                break;
            default:
                referenceQuestionAnswer = (0, utils_1.last)(state.answers.filter(function (a) { return rule.selectedReferenceQ.value == a.questionValue; }));
                break;
        }
        return referenceQuestionAnswer;
    };
    IncaVariableEval.prototype.getConditionOperator = function () {
        return {
            includesOptions: this.includesOption,
            doesNotIncludeOption: this.doesNotIncludeOption,
            equalNumberOptions: this.equalNumberOptions,
            greaterNumberOptions: this.greaterNumberOptions,
            lessNumberOptions: this.lessNumberOptions,
            stringContains: this.stringContains,
            stringDoesNotContain: this.stringDoesNotContain,
            stringEqauls: this.stringEqauls,
            stringDoesNotEqual: this.stringDoesNotEqual,
            likeText: this.likeText,
            matchesRegex: this.matchesRegex,
            numericGreaterThan: this.numericGreaterThan,
            numericGreaterThanOrEquals: this.numericGreaterThanOrEquals,
            numericLessThan: this.numericLessThan,
            numericLessThanOrEquals: this.numericLessThanOrEquals,
            numericEquals: this.numericEquals,
            numericDoesNotEqual: this.numericDoesNotEqual,
            isDisplayed: this.isDisplayed,
            isNotDisplayed: this.isNotDisplayed,
            includesOptionsWithRank: this.includesOptionsWithRank,
            doesNotIncludeOptionWithRank: this.doesNotIncludeOptionWithRank,
            isTargetsDetected: this.isTargetsDetected,
            isNotTargetsDetected: this.isNotTargetsDetected
        };
    };
    return IncaVariableEval;
}(IncaVariableBase_1.IncaVariableBase));
exports.default = IncaVariableEval;
//# sourceMappingURL=IncaVariableEval.js.map